<template>
  <div v-if="canAccess">
    <v-btn
      block
      text
      :color="color"
      class="ma-0"
      :class="{ 'v-btn--active elevation-15': active }"
      @click="navigate()"
    >
      <v-icon>
        {{ icon }}
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'ModuleBtn',
    props: {
      moduleName: {
        type: String,
        required: true
      },
      active: {
        type: Boolean,
        required: true
      },
      icon: {
        type: String,
        required: true
      }
    },
    computed: {
      canAccess() {
        return this.$can(`access-${this.moduleName}`)
      },
      color() {
        return this.active ? 'primary' : 'grey darken-2'
      }
    },
    methods: {
      navigate() {
        this.$router.push({ name: this.moduleName })
      }
    }
  }
</script>
